
function isBoolean(inboolean) {
    return inboolean !== null && inboolean !== undefined && typeof inboolean === "boolean"; 
}

export {
    isBoolean
};